import React from 'react';

import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const styled = withStyles(theme => {
  return {
    buttonProgress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12
    }
  };
});

const ButtonProgress = ({ classes, loading, children, ...rest }) => (
  <Button disabled={loading} {...rest}>
    {children}
    {loading && (
      <CircularProgress size={24} className={classes.buttonProgress} />
    )}
  </Button>
);

export default styled(ButtonProgress);
